import mediaTypeIds from '../constants/media-type-ids';
import buildIframeElementFromFieldsValues, {
  updateIframeMediaElementFromFieldsValues,
} from './build-iframe-element-from-fields-values';
import buildImageElementFromFieldsValues, {
  updateImageMediaElementFromFieldsValues,
} from './build-image-element-from-fields-values';
import buildLinkElementFromFieldsValues from './build-link-element-from-fields-values';

const buildMediaElementFromFieldsValues = (
  mediaTypeId,
  fieldsValues,
  mediaContainerElement,
  breakpoint
) => {
  if (!mediaTypeId) {
    throw new Error('`mediaTypeId` is required');
  }

  if (!Object.values(mediaTypeIds).includes(mediaTypeId)) {
    throw new Error(
      `Invalid mediaTypeId: ${mediaTypeId}. Expected one of: ${Object.values(mediaTypeIds).join(
        ', '
      )}`
    );
  }

  if (mediaTypeId === mediaTypeIds.VIDEO) {
    const iframeElement = buildIframeElementFromFieldsValues(fieldsValues);

    updateIframeMediaElementFromFieldsValues(mediaContainerElement);

    return iframeElement;
  }

  if (mediaTypeId === mediaTypeIds.IMAGE) {
    const imageElement = buildImageElementFromFieldsValues(fieldsValues);
    const linkElement = buildLinkElementFromFieldsValues(fieldsValues);

    updateImageMediaElementFromFieldsValues(mediaContainerElement, fieldsValues, breakpoint);

    if (linkElement) {
      linkElement.appendChild(imageElement.cloneNode(true));

      return linkElement;
    }

    return imageElement;
  }

  return null;
};

export default buildMediaElementFromFieldsValues;
